/* @flow */

import FieldKeysDDW from './FieldKeysDDW';
import FieldKeysDSW from './FieldKeysDSW';
import FieldKeysGeneric from './FieldKeysGeneric';

export default {
  ...FieldKeysGeneric,
  ...FieldKeysDDW,
  ...FieldKeysDSW,
  SPA_HEADLINE: 'spa.headline.application.label',
  SPA_HEADLINE_SUB: 'spa.headline.application.sub.label',
  SPA_SEARCH_LOCATE_ME: 'spa.search.locateMe.label',
  SPA_PGPH_NO_RESULTS_LABEL: 'spa.paragraph.noResults.label',
  SPA_PGPH_BACK_TO_MAP_LABEL: 'spa.paragraph.backToMap.label',
  SPA_PGPH_BACK_TO_LIST_LABEL: 'spa.paragraph.backToList.label',
  SPA_C_FILTERING: 'spa.filters',
  //SPA_C_FILTERING_SEARCH_RADIUS: 'spa.filters.searchRadius',
  //SPA_C_FILTERING_SEARCH_RADIUS_LABEL: 'spa.filters.searchRadius.label',
  //SPA_C_FILTERING_ACTIVITY_TYPES: 'spa.filters.activityTypes',
  //SPA_C_FILTERING_ACTIVITY_TYPES_LABEL: 'spa.filters.activityTypes.label',
  //SPA_C_FILTERING_PRODUCT_GROUPS: 'spa.filters.productGroups',
  //SPA_C_FILTERING_PRODUCT_GROUPS_LABEL: 'spa.filters.productGroups.label'
};
